import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../basics/accordion/Accordion';
import TextCopy from '../../basics/text/TextCopy';

const FAQ = ({
  params,
  locationHash,
  trackDetail,
  trackTopic,
}) => {
  const enhancedHeadline = (headline, index) => (params.groupsVisible ? `${String(index + 1).padStart(2, '0')}. ${headline}` : null);

  return (
    <Accordion
      title={params.headline}
      hash={params.hash}
      open={params.expanded}
      elementName="faq"
      locationHash={locationHash}
      thickArrow
    >
      {params.groups.map((group, index) => (
        <Accordion
          title={enhancedHeadline(group.name, index)}
          hash={group.hash}
          open={group.expanded || false}
          trackingFunction={trackTopic}
          key={group.hash}
          locationHash={locationHash}
        >
          {group.entries.map((entry) => (
            <Accordion
              title={entry.question}
              hash={entry.hash}
              open={entry.expanded || false}
              trackingFunction={trackDetail}
              key={entry.hash}
              locationHash={locationHash}
            >
              <TextCopy embedded raw>{entry.answer}</TextCopy>
            </Accordion>
          ))}
        </Accordion>
      ))}
    </Accordion>
  );
};

FAQ.propTypes = {
  params: PropTypes.object,
  locationHash: PropTypes.string,
  trackTopic: PropTypes.func,
  trackDetail: PropTypes.func,
};

export default FAQ;
